import { render, staticRenderFns } from "./splitBillForm.vue?vue&type=template&id=65e017b5&scoped=true&"
import script from "./splitBillForm.vue?vue&type=script&lang=js&"
export * from "./splitBillForm.vue?vue&type=script&lang=js&"
import style0 from "./splitBillForm.vue?vue&type=style&index=0&id=65e017b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e017b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e017b5')) {
      api.createRecord('65e017b5', component.options)
    } else {
      api.reload('65e017b5', component.options)
    }
    module.hot.accept("./splitBillForm.vue?vue&type=template&id=65e017b5&scoped=true&", function () {
      api.rerender('65e017b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Act/splitBillForm.vue"
export default component.exports